var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 17.5C2.08332 16.7424 3.66666 15.2273 6.66666 15.2273C9.66666 15.2273 11.25 13.4091 11.6667 12.5M6.66666 6.66667V4.16667C6.66666 3.24619 7.41285 2.5 8.33332 2.5H16.6667C17.5871 2.5 18.3333 3.24619 18.3333 4.16667V10.8333C18.3333 11.7538 17.5871 12.5 16.6667 12.5H13.9497M9.99999 5.83333H15M8.33332 10.8333C8.33332 11.7538 7.58713 12.5 6.66666 12.5C5.74618 12.5 4.99999 11.7538 4.99999 10.8333C4.99999 9.91286 5.74618 9.16667 6.66666 9.16667C7.58713 9.16667 8.33332 9.91286 8.33332 10.8333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.16669H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavClasses);
export default __webpack_public_path__ + "static/media/sidenav-classes.71d0f32a1316311fa3ad6e6cc418b0d3.svg";
export { ForwardRef as ReactComponent };